

const init = () => {

    const accordions = document.querySelectorAll('[data-accordion]');

    if (accordions) {
        accordions.forEach((accordion) => {
                
                const accordionItems = accordion.querySelectorAll('.accordion__item');
    
                accordionItems.forEach((item) => {
    
                    const accordionItemTrigger = item.querySelector('.accordion__trigger');
                    const accordionItemContent = item.querySelector('.accordion__content');
    
                    accordionItemTrigger.addEventListener('click', () => {
    
                        if (item.classList.contains('isOpen')) {
                            item.classList.remove('isOpen');
                            accordionItemContent.style.maxHeight = null;
                        } else {
                            item.classList.add('isOpen');
                            accordionItemContent.style.maxHeight = accordionItemContent.scrollHeight + 20 + "px";
                        }
    
                    });
    
                });
        });
    }
};

export default { init };